// Screen 1 — the per-team list of the 4 ritual tiles (+ legacy cards on General).
import React from 'react';
import { Switch } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { TYPES, IconTile, LegacyBadge } from './parts';

function Cell({ value }) {
  const muted = !value || value === 'Not set' || value === 'Never';
  return (
    <div className={'ck21__cell' + (muted ? ' ck21__cell--muted' : '')}>
      {value || 'Not set'}
    </div>
  );
}

export default function CheckinsList({
  rows,
  legacy,
  isDefault,
  onConfigure,
  onToggle,
  onBackToReport,
}) {
  const byKey = {};
  (rows || []).forEach((r) => (byKey[r.type] = r));

  return (
    <div className="ck21__inner">
      <span className="ck21__back" onClick={onBackToReport}>
        ‹ Back to today's standup
      </span>

      <div className="ck21__infobanner">
        <InfoCircleOutlined style={{ color: '#97A0AC', fontSize: 17 }} />
        Each team runs one of each check-in type. Enable or disable them here —
        there are no duplicates to manage.
      </div>

      <div className="ck21__card">
        <div className="ck21__thead">
          <div className="ck21__th">CHECK-IN</div>
          <div className="ck21__th">SCHEDULE</div>
          <div className="ck21__th">POSTS TO</div>
          <div className="ck21__th">LAST RUN</div>
          <div className="ck21__th">STATUS</div>
          <div className="ck21__th" />
        </div>
        {TYPES.map((type) => {
          const r = byKey[type.key] || {};
          return (
            <div className="ck21__row" key={type.key}>
              <div className="ck21__rowname">
                <IconTile type={type} />
                <div>
                  <div className="ck21__name">{type.name}</div>
                  {type.reco && <div className="ck21__reco">Recommended</div>}
                </div>
              </div>
              <Cell value={r.schedule} />
              <Cell value={r.postsTo} />
              <Cell value={r.lastRun} />
              <div>
                <Switch
                  checked={!!r.enabled}
                  onChange={(v) => onToggle(type, v)}
                />
              </div>
              <div
                className="ck21__configure"
                onClick={() => onConfigure(type)}
              >
                Configure
              </div>
            </div>
          );
        })}
      </div>

      {isDefault && legacy && legacy.length > 0 && (
        <div style={{ marginTop: 30 }}>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 10 }}>
            <div style={{ fontSize: 16, fontWeight: 700, color: '#16202E' }}>
              Legacy check-ins
            </div>
            <div style={{ fontSize: 13, color: '#97A0AC' }}>
              migrated from the old product · read-only schedule
            </div>
          </div>
          <div style={{ fontSize: 13.5, color: '#7A828D', margin: '6px 0 16px' }}>
            These don't follow the one-of-each rule. Wind them down as the team
            moves to the four rituals above.
          </div>
          <div className="ck21__legacy-grid">
            {legacy.map((l) => (
              <div className="ck21__legacy" key={l.id}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <div className="nm">{l.name}</div>
                  <LegacyBadge state={l.state} />
                </div>
                <div className="meta">
                  <div>
                    <div className="k">Owner</div>
                    <div className="v">{l.owner || '—'}</div>
                  </div>
                  <div>
                    <div className="k">Participants</div>
                    <div className="v">{l.participants}</div>
                  </div>
                  <div>
                    <div className="k">Reporting to</div>
                    <div className="v">{l.reportingTo || '—'}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
